/* Verhuisd uit sections/single-product.liquid: stond als inline script in het
   document (parse vóór de eerste paint). Liquid-waarden komen uit window.FLORAFY_PDP,
   gezet door de sectie vlak vóór deze scripts. */
var cfg = window.FLORAFY_PDP || {};
/**
 * Product FAQ Accordion for Specifications Section
 */
(function() {
  'use strict';

  class ProductFAQAccordion {
    constructor(container) {
      this.container = container;
      this.items = Array.from(container.querySelectorAll('[data-faq-item]'));
      this.init();
    }

    init() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        const answer = item.querySelector('.faq-item__answer');

        if (trigger && answer) {
          trigger.addEventListener('click', () => this.toggle(item));
          trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggle(item);
            }
          });
        }
      });
    }

    toggle(item) {
      const trigger = item.querySelector('[data-faq-trigger]');
      const answer = item.querySelector('.faq-item__answer');

      if (!trigger || !answer) return;

      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.collapse(trigger, answer);
      } else {
        this.expand(trigger, answer);
      }
    }

    expand(trigger, answer) {
      trigger.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
    }

    collapse(trigger, answer) {
      trigger.setAttribute('aria-expanded', 'false');
      answer.hidden = true;
    }
  }

  function initProductFAQ() {
    const faqContainer = document.querySelector('.product-faq-inline');
    if (faqContainer) {
      new ProductFAQAccordion(faqContainer);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFAQ);
  } else {
    initProductFAQ();
  }
})();

// Back-in-stock notification handler
(function() {
  function initBackInStockNotification() {
    const form = document.querySelector('.js-back-in-stock-form');
    if (!form) return;

    const emailInput = form.querySelector('.js-notify-email');
    const submitBtn = form.querySelector('.js-notify-submit');
    const messageEl = form.querySelector('.js-notify-message');
    const productId = form.dataset.productId;
    const variantId = form.dataset.variantId;

    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      const email = emailInput.value.trim();
      if (!email || !email.includes('@')) return;

      // Disable submit tijdens verwerking
      submitBtn.disabled = true;
      submitBtn.textContent = '...';

      try {
        // Send via Shopify Contact Form API
        const formData = new FormData();
        formData.append('contact[email]', email);
        formData.append('contact[subject]', 'Back-in-Stock Notificatie: ' + cfg.productTitle);
        formData.append('contact[body]', `
Nieuwe back-in-stock notificatie aanvraag:

Email: ${email}
Product: ${cfg.productTitle}
Product ID: ${productId}
Variant ID: ${variantId}
URL: ${cfg.productUrl}?variant=${variantId}
Datum: ${new Date().toLocaleString('nl-NL')}
        `.trim());

        const response = await fetch(cfg.rootUrl + 'contact', {
          method: 'POST',
          body: formData
        });

        // Also save to localStorage for backup
        const notifications = JSON.parse(localStorage.getItem('backInStockNotifications') || '[]');
        notifications.push({
          email: email,
          productId: productId,
          variantId: variantId,
          timestamp: new Date().toISOString(),
          productTitle: cfg.productTitle
        });
        localStorage.setItem('backInStockNotifications', JSON.stringify(notifications));

        // Success feedback
        messageEl.textContent = cfg.notifySuccess;
        messageEl.style.color = 'var(--color-primary, #7D7D4C)';
        messageEl.style.opacity = '1';
        messageEl.style.fontWeight = '600';

        emailInput.value = '';
        emailInput.disabled = true;
        submitBtn.textContent = '✓';
        submitBtn.style.backgroundColor = 'var(--color-primary, #7D7D4C)';

      } catch (error) {
        console.error('Back-in-stock notification error:', error);
        messageEl.textContent = cfg.notifyError;
        messageEl.style.color = '#d32f2f';
        messageEl.style.opacity = '1';
        submitBtn.disabled = false;
        submitBtn.textContent = cfg.notifyMe;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackInStockNotification);
  } else {
    initBackInStockNotification();
  }
})();
